export { DayOfWeekDto as DayOfWeek, TimeAccessTypeDto as TimeAccessType } from '@treasury/api/bo';
export type TimeAccessTypeLabel = 'Allowed all day' | 'Restricted all day' | 'Allowed time range';
